import React from 'react';
import { DocumentGenerator } from '../DocumentGenerator';
import { DocumentList } from '../DocumentList';

export function ManagementDocuments() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Documentos de Gestión</h1>
        <p className="mt-2 text-gray-600">
          Crea y gestiona documentos de gestión educativa con ayuda de IA
        </p>
      </div>
      
      <DocumentGenerator type="management" />
      <DocumentList type="management" />
    </div>
  );
}